const chart = [
  '#095174',
  '#bbdee4',
  '#67c392',
  '#abd16e',
  '#d2e0a2',
  '#efc998',
  '#fa955d',
  '#e78a9c',
];

export default chart;
